import { render, staticRenderFns } from "./CreditReceipt.vue?vue&type=template&id=25a0380e&scoped=true"
import script from "./CreditReceipt.vue?vue&type=script&lang=js"
export * from "./CreditReceipt.vue?vue&type=script&lang=js"
import style0 from "./CreditReceipt.vue?vue&type=style&index=0&id=25a0380e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a0380e",
  null
  
)

export default component.exports